import { createFileRoute, redirect } from '@tanstack/react-router';
import { PageContent } from '@/components/page-content';
import { PageHeader } from '@/components/page-header';
import { featuresOptions } from '@/hooks/query-options';
import { hasPermission } from '@/lib/permissions';
import { IntegrationCatalog } from '@/components/integrations-hub/integration-catalog';

export const Route = createFileRoute('/_auth/_side-layout/integrations/')({
  component: IntegrationsCatalogPage,
  beforeLoad: async ({ context }) => {
    // Direct-URL guard mirroring the nav's `integrations` flag gate.
    const features =
      await context.queryClient.ensureQueryData(featuresOptions());
    if (
      features.integrationsHub !== true ||
      !hasPermission(context.userRole, { organization: ['update'] })
    ) {
      throw redirect({ to: '/integrations/access' });
    }
  },
});

function IntegrationsCatalogPage() {
  return (
    <>
      <PageHeader
        title="Integrations"
        description="Connect Logspot to the tools where you run outbound, get notified, and build."
      />
      <PageContent>
        <IntegrationCatalog />
      </PageContent>
    </>
  );
}
